var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pageNum,
          "page-sizes": _vm.pageSizes,
          "page-size": _vm.pageSize,
          layout: "total,sizes,prev, pager, next, jumper",
          total: _vm.total,
          background: _vm.background,
        },
        on: {
          "size-change": _vm.sizeChange,
          "current-change": _vm.currentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }